import React from "react";
import Select from "react-select";
import styled from "styled-components";
import { colors } from "utils";

const Bar = styled.div`
  align-items: flex-end;
  background-color: ${colors.white};
  border: 1px solid ${colors.nightlyWoods200 || "#E5E7EB"};
  border-radius: 8px;
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  margin-bottom: 16px;
  padding: 16px;
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

const Label = styled.label`
  color: ${colors.nightlyWoods700 || "#374151"};
  font-size: 12px;
  font-weight: 600;
  margin: 0;
  text-transform: uppercase;
`;

export const FiltersBar = ({ filters }) => {
  const {
    grades,
    grade,
    setGrade,
    gradesLoading,
    units,
    unit,
    setUnit,
    unitsLoading,
    lessons,
    lesson,
    setLesson,
    sectionType,
    setSectionType,
    sectionTypeOptions,
  } = filters;

  return (
    <Bar>
      <Field>
        <Label>Grade</Label>
        <Select
          options={grades}
          value={grade}
          onChange={setGrade}
          isLoading={gradesLoading}
          placeholder="Select grade..."
          isClearable
        />
      </Field>
      <Field>
        <Label>Unit</Label>
        <Select
          options={units}
          value={unit}
          onChange={setUnit}
          isLoading={unitsLoading}
          placeholder={grade ? "Select unit..." : "Select grade first"}
          isClearable
          isDisabled={!grade}
        />
      </Field>
      <Field>
        <Label>Lesson</Label>
        <Select
          options={lessons}
          value={lesson}
          onChange={setLesson}
          placeholder={unit ? "Select lesson..." : "Select unit first"}
          isClearable
          isDisabled={!unit}
        />
      </Field>
      <Field>
        <Label>Section type</Label>
        <Select
          options={sectionTypeOptions}
          value={sectionType}
          onChange={setSectionType}
          placeholder={lesson ? "All" : "Select lesson first"}
          isDisabled={!lesson}
        />
      </Field>
    </Bar>
  );
};
